import React from "react";

import DialogContent from "@busbud/design-system-components/dist/DialogContent";
import Stack from "@busbud/design-system-components/dist/Stack";
import Text from "@busbud/design-system-components/dist/Text";

import { Markdown } from "@app/components/markdown";
import { useAppContext } from "@app/helpers/hooks";

import { useStyles } from "./cancel-dialog.styles";

export type CancelDialogBodyProps = {
  children?: React.ReactNode;
  tip?: string;
  classes?: Partial<Record<"content" | "message", string>>;
  classNames?: string;
};

export const CancelDialogBody: React.FC<CancelDialogBodyProps> = props => {
  const { translator } = useAppContext();
  const { classes: external_classes, classNames } = props;
  const { cx, classes: dialog_title_classes } = useStyles();
  const classes = external_classes || dialog_title_classes;

  const message = React.isValidElement(props.children) ? (
    props.children
  ) : (
    <Markdown
      className={cx("alert-markdown", classNames)}
      source={
        typeof props.children === "string"
          ? props.children
          : translator.t("!route.errors.default-text")
      }
    />
  );

  const tip = props.tip ? <Text size="sm">{props.tip}</Text> : null;

  return (
    <DialogContent className={classes.content}>
      <Stack direction="column" spacing={1}>
        {message}
        {tip}
      </Stack>
    </DialogContent>
  );
};
